<section class="table-page__card normas-config">
  <header class="normas-config__header">
    <div><h2>Indicadores por norma</h2><p>Elige y ordena los KPI de {{ anio }} para cada norma.</p></div>
    <a mat-button routerLink="/admin/bsc/indicadores" [queryParams]="{ anio: anio, idNorma: idNorma }">Ver indicadores generales</a>
    <button type="button" mat-button [disabled]="bloqueada" (click)="agregarNorma()">Agregar norma</button>
  </header>
  <p *ngIf="soloLectura">Solo lectura. Para editar, el año debe estar creado y abierto.</p>
  <output class="d-block mb-3" *ngIf="loading">Consultando normas y KPI…</output>
  <div role="alert" *ngIf="error">{{ error }} <button type="button" mat-button (click)="cargar()">Reintentar</button></div>
  <nav class="normas-config__tabs" aria-label="Norma a configurar">
    <button type="button" mat-button *ngFor="let n of normas" [attr.aria-pressed]="idNorma === n.idNorma"
      [disabled]="loading || guardando" (click)="elegir(n.idNorma)">{{ n.nombre }} ({{ n.total ?? 0 }}){{ n.activa === false ? ' · Inactiva' : '' }}</button>
  </nav>
  <div class="normas-config__acciones" *ngIf="norma">
    <button type="button" mat-button [disabled]="bloqueada" (click)="editarNorma()">Renombrar</button>
    <button type="button" mat-button [disabled]="bloqueada" (click)="cambiarEstado()">{{ norma.activa ? 'Desactivar' : 'Reactivar' }}</button>
    <span *ngIf="norma.activa === false">Lista conservada para auditoría. Reactiva la norma para editarla.</span>
  </div>
  <form *ngIf="editor as e" (ngSubmit)="guardarNorma()" class="normas-config__editor">
    <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
      <mat-label>Nombre de la norma</mat-label>
      <label for="bsc-norma-nombre" class="cdk-visually-hidden">Nombre de la norma</label>
      <input id="bsc-norma-nombre" matInput name="nombreNorma" [(ngModel)]="e.nombre" maxlength="60" required [disabled]="bloqueada" />
    </mat-form-field>
    <button type="submit" mat-button [disabled]="bloqueada || !e.nombre?.trim()">Guardar norma</button>
    <button type="button" mat-button [disabled]="guardando" (click)="editor = null">Cancelar</button>
  </form>
  <p *ngIf="!loading && !error && normas.length === 0">Aún no hay normas. Agrega la primera para definir su lista.</p>
  <div class="normas-config__columnas" *ngIf="norma && !loading && !error">
    <section aria-labelledby="bsc-kpi-disponibles">
      <h3 id="bsc-kpi-disponibles">KPI de las áreas</h3>
      <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
        <mat-label>Buscar objetivo, indicador o área</mat-label>
        <label for="bsc-norma-buscar" class="cdk-visually-hidden">Buscar objetivo, indicador o área</label>
        <input id="bsc-norma-buscar" matInput [(ngModel)]="filtro" />
      </mat-form-field>
      <p class="table-page__subtext">La estrella identifica los KPI sugeridos por las áreas para este año.</p>
      <fieldset *ngFor="let grupo of grupos" [disabled]="listaBloqueada">
        <legend>{{ grupo.area }}</legend>
        <div *ngFor="let k of grupo.kpis" class="normas-config__opcion">
          <input type="checkbox" [id]="'bsc-norma-kpi-' + k.id" [checked]="ids.includes(k.id)" (change)="alternar(k.id)" />
          <label [for]="'bsc-norma-kpi-' + k.id">{{ k.objetivo }} <span *ngIf="k.sugerido" aria-label="Sugerido por el área">★</span><small>{{ k.indicador }}</small></label>
        </div>
      </fieldset>
      <p *ngIf="grupos.length === 0">No hay KPI que coincidan.</p>
    </section>
    <section aria-labelledby="bsc-kpi-elegidos">
      <h3 id="bsc-kpi-elegidos">Lista elegida ({{ ids.length }})</h3>
      <ol class="normas-config__lista">
        <li *ngFor="let k of elegidos; let i = index">
          <strong>{{ k.objetivo }}</strong><small>{{ k.area }}</small>
          <div class="normas-config__acciones">
            <button type="button" mat-button [disabled]="listaBloqueada || i === 0" [attr.aria-label]="'Subir ' + k.objetivo" (click)="mover(i, -1)">Subir</button>
            <button type="button" mat-button [disabled]="listaBloqueada || i === ids.length - 1" [attr.aria-label]="'Bajar ' + k.objetivo" (click)="mover(i, 1)">Bajar</button>
            <button type="button" mat-button [disabled]="listaBloqueada" [attr.aria-label]="'Quitar ' + k.objetivo" (click)="alternar(k.id)">Quitar</button>
          </div>
        </li>
      </ol>
      <p *ngIf="ids.length === 0">Sin KPI elegidos. Guardar dejará vacía la lista de esta norma.</p>
      <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary" [disabled]="listaBloqueada" (click)="guardarLista()">{{ guardando ? 'Guardando…' : 'Guardar lista' }}</button>
    </section>
  </div>
  <output class="d-block mb-3" *ngIf="mensaje">{{ mensaje }}</output>
</section>
